"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAIN_NAVIGATION = void 0;
var MAIN_NAVIGATION = {
  LINK__PRODUCTS: 'navigationBar-link-products',
  LINK__ORDERS: 'navigationBar-link-orders',
  LINK__SUPPLIERS: 'navigationBar-link-suppliers',
  BUTTON__ACCOUNT_SETTINGS: 'navigationBar-button-settingsDropdown',
  BUTTON__MY_SETTINGS: 'navigationBar-button-mySettings',
  BUTTON__GROUP_SETTINGS: 'navigationBar-button-GroupSettings',
  BUTTON__SWITCH_TO_OUTLET: 'navigationBar-button-switchTo',
  BUTTON__CART: 'navigationBar-button-cart'
};
exports.MAIN_NAVIGATION = MAIN_NAVIGATION;